import script from "./enquiry_list.vue?vue&type=script&setup=true&lang=js"
export * from "./enquiry_list.vue?vue&type=script&setup=true&lang=js"

import "./enquiry_list.vue?vue&type=style&index=0&id=136f6cd0&lang=css"

const __exports__ = script;

export default __exports__